import React from 'react'
import { FileText } from 'lucide-react'
import styles from './MediaThumbnail.module.scss'

interface MediaThumbnailProps {
  url: string
  name: string
  filename: string
  isImage: boolean
  selected?: boolean
  onClick?: () => void
  className?: never
}

export const MediaThumbnail: React.FC<MediaThumbnailProps> = ({
  url, name, filename, isImage, selected = false, onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={[styles.button, selected ? styles.selected : styles.unselected].join(' ')}
  >
    {isImage ? (
      <img src={url} alt={name} className={styles.image} />
    ) : (
      <div className={styles.filePlaceholder}>
        <FileText className={styles.fileIcon} />
        <span className={styles.fileName}>{filename}</span>
      </div>
    )}
    <div className={styles.overlay} />
  </button>
)
